import React, {forwardRef, useEffect, useRef, useState} from 'react';
import BaseMachineAssignmentManageModal, {
  getEmptyData as getEmptyMachineAssignmentData,
} from './BaseMachineAssignmentManageModal';
import useMachineAssignment from '../hooks/useMachineAssignment';
import enumList from '../../../utils/enumList';
import {useDispatch} from 'react-redux';
import {showMessage} from '../../../utils/modalHelper';
const {messageModalMode} = enumList;

const MachineAssignmentEditModal = (props, ref) => {
  const {
    machineID,
    customerData,
    setMachineID,
    getAssignments,
    modalRef: currentModalRef,
    listModalRef,
  } = props;
  const dispatch = useDispatch();
  const [machines, setMachines] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const [machineAssignment, setMachineAssignment] = useState(
    getEmptyMachineAssignmentData(),
  );
  const {updateAssignment, fetchAssignment} = useMachineAssignment({
    customerCode: customerData.customerCode,
    dispatch,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsValid(true);
    let response = {};
    try {
      const {deliveryDate, flgIsResold, flgOnSiteCheck} = machineAssignment;
      if (!ref.current.getElementsByTagName('form')[0].checkValidity()) {
        setIsValid(false);
        return;
      }
      response = await updateAssignment(machineID, {
        deliveryDate,
        flgIsResold,
        flgOnSiteCheck,
      });
      showMessage(messageModalMode.info, '更新成功');
      setMachineAssignment(getEmptyMachineAssignmentData());
      setMachines([]);
      setMachineID('');
    } catch (error) {
      console.error(error);
      showMessage(messageModalMode.error, 'error', response?.payload?.message);
    } finally {
      if (ref.current instanceof HTMLDivElement) {
        currentModalRef.current.hide();
        getAssignments();
      }
    }
  };

  const propsOfBaseComponent = {
    ...props,
    title: {
      content: `編輯機器綁定`,
    },
    machines,
    handleSubmit,
    data: machineAssignment,
    setData: setMachineAssignment,
    isValid,
    currentModalRef,
    listModalRef,
  };

  const updateMachineList = async () => {
    const {
      customerCode,
      customerName,
      machineId: resMachineID,
      machineSerialNumber,
      deliveryDate,
      flgIsResold,
      flgOnSiteCheck,
    } = await fetchAssignment(machineID);
    setMachineAssignment({
      customerCode,
      customerName,
      machines: [
        {
          id: resMachineID,
          label: machineSerialNumber,
        },
      ],
      deliveryDate,
      flgIsResold,
      flgOnSiteCheck,
    });
    setMachines([
      {
        id: resMachineID,
        label: machineSerialNumber,
      },
    ]);
  };

  useEffect(() => {
    if (!(ref.current instanceof HTMLDivElement)) {
      return;
    }
    const {customerCode} = customerData;
    const initialize = async () => {
      if (!(customerCode && machineID)) {
        console.warn(new Error('no customer code found'));
        if (ref.current instanceof HTMLDivElement) {
          currentModalRef.current.hide();
        }
        return;
      }
      await updateMachineList();
    };
    ref.current.addEventListener('shown.bs.modal', initialize);
    return () => {
      if (!(ref.current instanceof HTMLDivElement)) {
        return;
      }
      ref.current.removeEventListener('shown.bs.modal', initialize);
    };
  }, [machineID, customerData]);

  return (
    <BaseMachineAssignmentManageModal
      type="edit"
      ref={ref}
      {...propsOfBaseComponent}
    />
  );
};

export default forwardRef(MachineAssignmentEditModal);
